<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-icon-success swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">

  <div>
    <div class="swal2-header">
      <div class="swal2-icon swal2-success swal2-icon-show" style="display: flex;">
        <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
        <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
        <div class="swal2-success-ring"></div>
        <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
        <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;">Zahlungsmethode hinzugefügt.</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;">
        Bitte informieren Sie nun Ihren Ladepark-Verwalter, damit er Sie an den Ladestationen autorisiert.
      </div>
    </div>
  </div>

  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button type="button" id="ok" class="btn btn-danger" aria-label="" style="display: inline-block;" (click)="onConfirmClick()" i18n="@@OkButton">OK</button>
  </div>
</div>
